module.exports = __webpack_public_path__ + "img/SCX.df57ee95.png";